var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import * as i0 from "@angular/core";
var ColorService = /** @class */ (function () {
    function ColorService() {
    }
    ColorService.prototype._rgbToDecimal = function (rgb) {
        var result = rgb.map(function (value) {
            return value / 255;
        });
        return result;
    };
    ColorService.prototype._rgbFromDecimal = function (rgb) {
        var result = rgb.map(function (value) {
            return Math.round(value * 255);
        });
        return result;
    };
    ColorService.prototype.hexToRgba = function (hex, asDecimal) {
        if (asDecimal === void 0) { asDecimal = false; }
        // normalize hex
        hex = hex
            .replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function (m, r, g, b) { return [r, r, g, g, b, b].join(''); }) // #fff -> #ffffff
            .replace(/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i, function (m, r, g, b) { return [r, g, b, 'ff'].join(''); }); // #ffffff -> #ffffffff
        var regex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex); // #ffffffff
        var red = parseInt(regex[1], 16);
        var green = parseInt(regex[2], 16);
        var blue = parseInt(regex[3], 16);
        var alpha = parseInt(regex[4], 16) / 255; // important: 0...1
        if (asDecimal) {
            var rgb = this._rgbToDecimal([red, green, blue]);
            return [rgb[0], rgb[1], rgb[2], alpha];
        }
        else {
            return [red, green, blue, alpha];
        }
    };
    ColorService.prototype.hexToRgb = function (hex, asDecimal) {
        if (asDecimal === void 0) { asDecimal = false; }
        var rgba = this.hexToRgba(hex, asDecimal);
        return [
            rgba[0],
            rgba[1],
            rgba[2]
        ];
    };
    ColorService.prototype.rgbToHex = function (rgb, isDecimal) {
        if (isDecimal === void 0) { isDecimal = false; }
        if (isDecimal) {
            return this.toHex(this._rgbFromDecimal(rgb));
        }
        else {
            return this.toHex(rgb);
        }
    };
    ColorService.prototype.rgbaToHex = function (rgba, isDecimal) {
        if (isDecimal === void 0) { isDecimal = false; }
        var red = rgba[0];
        var green = rgba[1];
        var blue = rgba[2];
        var alpha = rgba[3] * 255; // important: 0...1 -> 0...255
        if (isDecimal) {
            return this.toHex(__spread(this._rgbFromDecimal([red, green, blue]), [alpha]));
        }
        else {
            return this.toHex([red, green, blue, alpha]);
        }
    };
    ColorService.prototype.toHex = function (values) {
        var hex = values
            .map(function (value) {
            var hexString = value.toString(16);
            return hexString.length % 2 ? "0" + hexString : hexString;
        })
            .join('');
        return "#" + hex;
    };
    ColorService.ngInjectableDef = i0.defineInjectable({ factory: function ColorService_Factory() { return new ColorService(); }, token: ColorService, providedIn: "root" });
    return ColorService;
}());
export { ColorService };
